package com.exura.features.userprofile.data.mappers

import com.exura.features.userprofile.data.remote.dto.DoctorProfileDto
import com.exura.features.userprofile.domain.model.DoctorProfile
import dev.gitlive.firebase.firestore.CollectionReference

class DoctorProfileMappers : ProviderUserSettingsMappers<DoctorProfile, DoctorProfileDto> {
    override fun toDto(model: DoctorProfile): DoctorProfileDto = DoctorProfileDto(
        email = model.email,
        fullName = model.fullName,
        specialization = model.specialization
    )

    override fun toDomain(dto: DoctorProfileDto, collection: CollectionReference?, id: String?): DoctorProfile = DoctorProfile(
        firebaseDocId = id,
        firebaseDocPrefix = collection,
        email = dto.email,
        fullName = dto.fullName,
        specialization = dto.specialization
    )
}
